import React from "react";
import AddCroppedImage from "components/bootstrap/AddCroppedImage";
import { Controller } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { croppedImageSchema } from "../FormStepsProps";

const CustomImageController = ({
  name,
  control,
  image,
  setValue,
  canvasImages,
  setCurrentCroppedButton,
  currentCroppedButton,
  errors,
  addCroppedImageArray,
}: croppedImageSchema) => {
  const { t } = useTranslation();
  const requiredImagesNames = ["licenseNumberPicture", "offencePicture"];

  const isImageRequired = () => {
    if (requiredImagesNames.includes(name)) return true;
    return false;
  };
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isImageRequired() }}
      render={({ field: { value: imageValule } }) => (
        <>
          <AddCroppedImage
            src={image.src}
            text={image.text}
            className="cropped-image-container fixed-height relative"
            backgroundColor={image.backgroundColor}
            name={name}
            canvasImages={canvasImages[name]}
            setCurrentCroppedButton={setCurrentCroppedButton}
            currentCroppedButton={currentCroppedButton}
            addCroppedImageArray={addCroppedImageArray}
            setValue={setValue}
            value={imageValule}
          />
          {errors[name] && <span>{t("validationRequired")}</span>}
          {!isImageRequired() && image.src !== null && (
            <Controller
              name="extraPictureTitle"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <Form.Group controlId={`${image.name}Title`}>
                  <Form.Control
                    type="text"
                    value={value || ""}
                    onChange={onChange}
                    isInvalid={!!errors[`${image.name}Title`]}
                    placeholder={t("addTitle")}
                  />
                  {errors.extraPictureTitle && (
                    <Form.Control.Feedback type="invalid">
                      {t("validationRequired")}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              )}
            />
          )}
        </>
      )}
    />
  );
};

export default CustomImageController;
